module.exports = __webpack_public_path__ + "img/vmc_aniv18_24Aug2021.5b7a1fb0.jpg";